// useMailingConfirm.ts

import { useCallback, SetStateAction } from 'react'
import { useCommonLoader } from '../../../../../common/hooks/useCommonLoader'
import { getSalesApi } from '../../../../../salesApi/salesApi'
import { PromoInterface } from '../../../../../common/types/interfaces'

export const useMailingConfirm = (
  getList: () => void,
  setModalActive: React.Dispatch<SetStateAction<boolean>>,
  current?: PromoInterface,
) => {
  const { showCommonLoader, hideCommonLoader } = useCommonLoader()

  const confirmMailing = useCallback(async () => {
    try {
      showCommonLoader()
      if (current?.id) {
        const api = getSalesApi()
        await api.startMailing({ promoId: current.id })
        await getList()
        setModalActive(false)
      }
    } catch (error: any) {
    } finally {
      hideCommonLoader()
    }
  }, [setModalActive, showCommonLoader, hideCommonLoader, current, getList])

  return {
    confirmMailing,
  }
}
